import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './AppProviders';
import { AuthProvider } from '@/auth/AuthProvider';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { router } from '@/routes';

/** Composition root: error boundary → providers → session bootstrap → router. */
export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </AppProviders>
    </ErrorBoundary>
  );
}
